import React from 'react'

const Give = () => {
  return (
    <>
      <div style={{ fontSize: "40px", marginTop: "200px" }}>Give</div>
      <div style={{ fontSize: "40px", marginTop: "10px" }}>Coming Soon...</div>
    </>
  )
}

export default Give